import { render, staticRenderFns } from "./ComingSoonModal.vue?vue&type=template&id=5ca95b25&scoped=true"
import script from "./ComingSoonModal.vue?vue&type=script&lang=js"
export * from "./ComingSoonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca95b25",
  null
  
)

export default component.exports